import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import CookieConsent from "./components/CookieConsent";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ChangePassword from "./pages/ChangePassword";
import Dashboard from "./pages/Dashboard";
import Ingredients from "./pages/Ingredients";
import IngredientForm from "./pages/IngredientForm";
import Recipes from "./pages/Recipes";
import RecipeBuilder from "./pages/RecipeBuilder";
import Admin from "./pages/Admin";
import Companies from "./pages/Companies";
import { Privacy, Imprint, Terms } from "./pages/Legal";
import { Toaster } from "./components/ui/sonner";

function Protected({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public marketing site */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registrieren" element={<Register />} />
          <Route path="/passwort-aendern" element={<ChangePassword />} />
          <Route path="/datenschutz" element={<Privacy />} />
          <Route path="/impressum" element={<Imprint />} />
          <Route path="/agb" element={<Terms />} />

          {/* Protected app */}
          <Route path="/app" element={<Protected><Dashboard /></Protected>} />
          <Route path="/zutaten" element={<Protected><Ingredients /></Protected>} />
          <Route path="/zutaten/:id" element={<Protected><IngredientForm /></Protected>} />
          <Route path="/rezepte" element={<Protected><Recipes /></Protected>} />
          <Route path="/rezepte/:id" element={<Protected><RecipeBuilder /></Protected>} />
          <Route path="/admin" element={<Protected><Admin /></Protected>} />
          <Route path="/firmen" element={<Protected><Companies /></Protected>} />
        </Routes>
        <Toaster position="top-right" richColors />
        <CookieConsent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
